export const sharedStyles = {
  generalContainer: {
    minHeight: "100vh",
    width: "100%",
  },

  innerContainer: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
    padding: 20,
  },

  secondaryColor: {
    color: "secondary.main",
  },

  sharedMainContainer: {
    overflowX: "hidden",
    height: "100vh",
    pb: "40px",
  },

  tableAvatarStyle: { width: "60px", height: "60px" },

  horizontalContent: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: "40px",
  },

  verticalContent: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },

  dividedFormContainer: {
    display: "flex",
    gap: "20px",

    "@media(max-width:800px)": { flexDirection: "column" },
  },

  dynamicPriceInputsContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-around",
    gap: "10px",

    "@media(max-width:600px)": { flexDirection: "column" },
  },

  serviceEmployeesGrid: {
    display: "flex",
    overflowX: "auto",
    whiteSpace: "nowrap",
    width: "100%",
    p: "10px 0px",
    gap: "20px",
  },

  appointmentsList: {
    overflowY: "auto",
    boxShadow:
      "inset 0px 15px 10px -10px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -10px rgba(0, 0, 0, 0.05)",
    "@media (max-width: 900px)": { width: "100%" },
    borderRadius: "10px",
  },

  clientMainContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "10px 0px",
    padding: "0px 30px",
  },

  loadingContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginY: 10,
  },

  horizontalScrollSection: {
    display: "flex",
    overflowX: "auto",
    whiteSpace: "nowrap",
    width: "100%",
    p: "10px 0px",
    gap: "20px",
  },
};
